import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a2675b6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "badge" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-user fa-lg mr-2 mt-2" })
], -1));
const _hoisted_3 = { class: "level is-mobile" };
const _hoisted_4 = { class: "adaptiveLabel" };
const _hoisted_5 = {
    key: 0,
    class: "tag is-info is-light is-rounded has-text-weight-bold ml-1"
};
const _hoisted_6 = {
    key: 1,
    class: "tag is-info is-light is-rounded has-text-weight-bold ml-1"
};
const _hoisted_7 = {
    key: 2,
    class: "tag is-warning is-light is-rounded has-text-weight-bold ml-1"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitizenBadge',
    props: {
        citizen: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_ctx.citizen ? _ctx.citizen.displayName : "Missing Name") + " ", 1),
                        ((_b = (_a = _ctx.citizen) === null || _a === void 0 ? void 0 : _a.programs) === null || _b === void 0 ? void 0 : _b.includes('lift_2_0'))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "LIFT 2.0"))
                            : _createCommentVNode("", true),
                        (((_c = _ctx.citizen) === null || _c === void 0 ? void 0 : _c.housingReadinessLocation) == 'PRYOR_STREET')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Pryor St."))
                            : _createCommentVNode("", true),
                        ((_e = (_d = _ctx.citizen) === null || _d === void 0 ? void 0 : _d.assignedCareProvider) === null || _e === void 0 ? void 0 : _e.isTestPartner)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Test"))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
